<template>
    <v-card class="scrollable-container elevation-5">
        <v-card-title>
            <div>Venue Management System</div>
        </v-card-title>
        <v-card-text class="scrollable-content text-h5">
            <div></div>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'HomePage'
};
</script>

<style lang="scss"></style>
